import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import commonDE from './common-de.json';
import commonEN from './common-en.json';
import thedaDE from './theda-de.json';
import thedaEN from './theda-en.json';
import tlksimDE from './tlksim-de.json';
import tlksimEN from './tlksim-en.json';
import pandemicDE from './pandemic-de.json';
import pandemicEN from './pandemic-en.json';
import logphDE from './logph-de.json';
import logphEN from './logph-en.json';
import hxDE from './hx-de.json';
import hxEN from './hx-en.json';
import mcCabeThieleDE from './mcCabeThiele-de.json';
import mcCabeThieleEN from './mcCabeThiele-en.json';
import { syncMomentLocale } from '../../utils/locale/dateLocale';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    // we init with resources
    resources: {
      de: {
        common: commonDE,
        theda: thedaDE,
        tlksim: tlksimDE,
        pandemic: pandemicDE,
        logph: logphDE,
        hx: hxDE,
        mcCabeThiele: mcCabeThieleDE,
      },
      en: {
        common: commonEN,
        theda: thedaEN,
        tlksim: tlksimEN,
        pandemic: pandemicEN,
        logph: logphEN,
        hx: hxEN,
        mcCabeThiele: mcCabeThieleEN,
      },
    },
    fallbackLng: 'de',
    fallbackNS: 'common',
    // Together these guarantee `i18n.language` is always exactly 'de' or 'en':
    // the detector reports region-tagged codes ('en-US', 'de-AT') and i18next would
    // otherwise store them verbatim, breaking every `i18n.language === 'en'` check.
    // Stripping the region here means the rest of the app never has to think about it.
    supportedLngs: ['de', 'en'],
    detection: {
      convertDetectedLanguage: (lng: string) => lng.split('-')[0],
    },
    debug: false,
    // have a common namespace used around the full app
    ns: ['common', 'theda', 'tlksim', 'pandemic'],
    interpolation: {
      escapeValue: false, // not needed for react
    },
  });

// keep moment's locale in sync with the app language, app-wide
syncMomentLocale(i18n.language);
i18n.on('languageChanged', syncMomentLocale);

export default i18n;
